import React, { useEffect, useState } from 'react';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import './ScrollArrow.css';

const ScrollArrow = () => {
  const [isBottom, setIsBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const bottom = document.documentElement.scrollHeight - 100;

      setIsBottom(scrollPosition >= bottom);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // initial check

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const scrollToBottom = () => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });

  return (
    <button
      className="scroll-arrow"
      onClick={isBottom ? scrollToTop : scrollToBottom}
      aria-label={isBottom ? 'Remonter' : 'Descendre'}
    >
      {isBottom ? <FaArrowUp /> : <FaArrowDown />}
    </button>
  );
};

export default ScrollArrow;
